import { useState } from 'react'
import { assetUrl } from '@/utils/assetUrl'

interface AvatarProps {
  photoUrl?: string | null
  fallbackName?: string
  size?: number
  className?: string
}

const PLACEHOLDER_SRC = '/avatar-male.png'

/**
 * 2-stufiger Avatar-Fallback (vereinfacht 2026-05-26):
 *   1. echtes Foto (wenn photoUrl gesetzt + lädt)
 *   2. geschlechtsneutrales Platzhalter-Bild
 *
 * Beide PNGs unter /public/avatar-{male,female}.png zeigen seit
 * 2026-05-26 dasselbe generische Person-Icon — historische Pfade,
 * eine spätere PNG-Konsolidierung ist Follow-up.
 */
export default function Avatar({
  photoUrl,
  fallbackName,
  size = 48,
  className = '',
}: AvatarProps) {
  const [imgError, setImgError] = useState(false)

  const showRealPhoto = photoUrl && !imgError
  // bg-fom-50 nur als Loading-Hintergrund fuer echte Fotos. Beim Platzhalter
  // bleibt der Container transparent, weil das Platzhalter-PNG selbst einen
  // Alpha-Channel hat — sonst scheint die Container-Farbe durch.
  const photoClass = `rounded-full overflow-hidden border-2 border-fom-100 bg-fom-50 flex items-center justify-center shrink-0 ${className}`
  const placeholderClass = `rounded-full overflow-hidden border-2 border-fom-100 flex items-center justify-center shrink-0 ${className}`
  const style = { width: size, height: size }

  if (showRealPhoto) {
    return (
      <div className={photoClass} style={style}>
        <img
          src={photoUrl!}
          alt={fallbackName ?? ''}
          className="w-full h-full object-cover"
          onError={() => setImgError(true)}
        />
      </div>
    )
  }

  return (
    <div className={placeholderClass} style={style}>
      <img
        src={assetUrl(PLACEHOLDER_SRC)}
        alt={fallbackName ?? ''}
        className="w-full h-full object-cover"
      />
    </div>
  )
}
